/* eslint-disable arrow-body-style */
/* eslint-disable react/prop-types */
import React from 'react';
import Lottie from "lottie-react";
import cardSpot from './10MM_CardSpot_NoLoop_02_Lottie.json';

const CardSpot = (props) => {
    return (
        <Lottie animationData={JSON.parse(JSON.stringify(cardSpot))} {...props}/>
    );
}

export default CardSpot;



// WEBPACK FOOTER //
// ./frontend/pages/LiveMarkets/animations/cardSpot/cardSpot.jsx